import React, { useRef, useState } from "react";
import { TextField, Button, Typography, CircularProgress, FormControl, InputLabel, Select, OutlinedInput, MenuItem, Checkbox, ListItemText } from "@mui/material";
import { Send } from "@mui/icons-material";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import {
  addCampaignMasterData,
  getCampaign,
} from "../../redux/features/clicksSlice";
import { clearTextFields } from "../../utils/clearTextFields";

const AddRow = ({ setShowInput }) => {
  // console.log(setShowInput, "setShowInput");
  const dispatch = useDispatch();
  const site_nameRef = useRef(null);
  const host_mid_nameRef = useRef(null);
  const url_matchRef = useRef(null);
  const table_nameRef = useRef(null);
  const cart_urlRef = useRef(null);
  const order_page_urlRef = useRef(null);
  const fb_pixel_idRef = useRef(null);
  const fb_pixel_pagesRef = useRef(null);
  const blocked_pagesRef = useRef(null);
  const session_wt_minRef = useRef(null);
  const live_onRef = useRef(null);
  const cashback_affRef = useRef(null);
  const normal_page_per_kRef = useRef(null);
  const cart_page_perRef = useRef(null);
  const min_no_visitsRef = useRef(null);
  const countryRef = useRef(null);
  const country_exceptRef = useRef(null);
  
  const deviceRef = useRef({ value: "" }); // dummy ref for clearTextFields

  const [selectedDevices, setSelectedDevices] = useState([]);
  const handleDeviceChange = (event) => {
    const {
      target: { value },
    } = event;
    setSelectedDevices(
      typeof value === "string" ? value.split(",") : value
    );
  };

  const black_list_aff_wait_minRef = useRef(null);
  const our_aff_wait_minRef = useRef(null);
  const aff_activeRef = useRef(null);
  const retargetting_activeRef = useRef(null);
  const data_actRef = useRef(null);
  const aff_wait_hrRef = useRef(null);

  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const clearError = (field) => {
    setErrors((prev) => (prev[field] ? { ...prev, [field]: false } : prev));
  };

  const REQUIRED_FIELDS = [
    "site_name",
    "host_mid_name",
    "url_match",
    "table_name",
    "cart_url",
    "normal_page_per_k",
    "cart_page_per",
    "min_no_visits",
    "black_list_aff_wait_min",
    "our_aff_wait_min",
    "retargetting_active",
    "data_act",
    "aff_wait_hr",
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();

    // -------Adding inputvalues to form data OBJ-----//
    const formData = {};
    formData.site_name = site_nameRef.current ? site_nameRef.current.value : "";
    formData.host_mid_name = host_mid_nameRef.current
      ? host_mid_nameRef.current.value
      : "";
    formData.url_match = url_matchRef.current ? url_matchRef.current.value : "";
    formData.table_name = table_nameRef.current
      ? table_nameRef.current.value
      : "";
    formData.cart_url = cart_urlRef.current ? cart_urlRef.current.value : "";
    formData.order_page_url = order_page_urlRef.current ? order_page_urlRef.current.value : "";
    formData.fb_pixel_id = fb_pixel_idRef.current ? fb_pixel_idRef.current.value : "";
    formData.fb_pixel_pages = fb_pixel_pagesRef.current ? fb_pixel_pagesRef.current.value : "";
    formData.blocked_pages = blocked_pagesRef.current ? blocked_pagesRef.current.value : "";
    formData.session_wt_min = session_wt_minRef.current ? session_wt_minRef.current.value : "";
    formData.live_on = live_onRef.current ? live_onRef.current.value : "";
    formData.cashback_aff = cashback_affRef.current
      ? cashback_affRef.current.value
      : "";
    formData.normal_page_per_k = normal_page_per_kRef.current
      ? normal_page_per_kRef.current.value
      : "";
    formData.cart_page_per = cart_page_perRef.current
      ? cart_page_perRef.current.value
      : "";
    formData.min_no_visits = min_no_visitsRef.current
      ? min_no_visitsRef.current.value
      : "";
    formData.country = countryRef.current ? countryRef.current.value : "";
    formData.country_except = country_exceptRef.current
      ? country_exceptRef.current.value
      : "";
    formData.device = selectedDevices.join(",");
    formData.black_list_aff_wait_min = black_list_aff_wait_minRef.current
      ? black_list_aff_wait_minRef.current.value
      : "";
    formData.our_aff_wait_min = our_aff_wait_minRef.current
      ? our_aff_wait_minRef.current.value
      : "";
    formData.aff_active = aff_activeRef.current
      ? aff_activeRef.current.value
      : "";
    formData.retargetting_active = retargetting_activeRef.current
      ? retargetting_activeRef.current.value
      : "";
    formData.data_act = data_actRef.current ? data_actRef.current.value : "";
    formData.aff_wait_hr = aff_wait_hrRef.current
      ? aff_wait_hrRef.current.value
      : "";

    // -------Adding inputvalues to form data OBJ-----//

    // -------Validate mandatory fields-----//
    const newErrors = {};
    REQUIRED_FIELDS.forEach((field) => {
      const value = formData[field];
      if (value === undefined || value === null || value.toString().trim() === "") {
        newErrors[field] = true;
      }
    });

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      toast.error("Please fill all mandatory fields", {
        position: "top-center",
        autoClose: 3000,
      });
      return;
    }

    setErrors({});

    setIsLoading(true);
    try {
      setShowInput(false);
      dispatch(addCampaignMasterData(formData));
      dispatch(getCampaign());
      toast.success("Added Successfully!", {
        position: "top-center",
        autoClose: 3000,
      });
      setSelectedDevices([]);

      clearTextFields(
        site_nameRef,
        host_mid_nameRef,
        url_matchRef,
        table_nameRef,
        cart_urlRef,
        order_page_urlRef,
        fb_pixel_idRef,
        fb_pixel_pagesRef,
        blocked_pagesRef,
        session_wt_minRef,
        live_onRef,
        cashback_affRef,
        normal_page_per_kRef,
        cart_page_perRef,
        min_no_visitsRef,
        countryRef,
        country_exceptRef,
        deviceRef,
        black_list_aff_wait_minRef,
        our_aff_wait_minRef,
        aff_activeRef,
        retargetting_activeRef,
        data_actRef,
        aff_wait_hrRef
      );
    } catch (error) {
      toast.error("Something went wrong", {
        position: "top-center",
        autoClose: 3000,
      });
      console.error("Error creating row:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Typography variant="h4" sx={{ paddingLeft: "20px" }}>
        Campaigns
      </Typography>
      <form
        onSubmit={handleSubmit}
        encType="multipart/form-data"
        noValidate
        style={{ padding: "20px", display: "flex", flexDirection: "column" }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "20px",
          }}
        >
          <TextField
            label="site_name"
            required
            inputRef={site_nameRef}
            onChange={() => clearError("site_name")}
            error={!!errors.site_name}
            helperText={errors.site_name ? "This field is required" : ""}
            sx={{ width: "48%" }}
          />
          <TextField
            label="host_mid_name"
            required
            inputRef={host_mid_nameRef}
            onChange={() => clearError("host_mid_name")}
            error={!!errors.host_mid_name}
            helperText={errors.host_mid_name ? "This field is required" : ""}
            sx={{ width: "48%" }}
          />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "20px",
          }}
        >
          <TextField
            label="url_match"
            required
            inputRef={url_matchRef}
            onChange={() => clearError("url_match")}
            error={!!errors.url_match}
            helperText={errors.url_match ? "This field is required" : ""}
            sx={{ width: "48%" }}
          />
          <TextField
            label="table_name"
            required
            inputRef={table_nameRef}
            onChange={() => clearError("table_name")}
            error={!!errors.table_name}
            helperText={errors.table_name ? "This field is required" : ""}
            sx={{ width: "48%" }}
          />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "20px",
          }}
        >
          <TextField
            label="cart_url"
            required
            inputRef={cart_urlRef}
            onChange={() => clearError("cart_url")}
            error={!!errors.cart_url}
            helperText={errors.cart_url ? "This field is required" : ""}
            sx={{ width: "48%" }}
          />
          <TextField
            label="order_page_url"
            inputRef={order_page_urlRef}
            sx={{ width: "48%" }}
          />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "20px",
          }}
        >
          <TextField
            label="fb_pixel_id"
            inputRef={fb_pixel_idRef}
            sx={{ width: "48%" }}
          />
          <TextField
            label="fb_pixel_pages"
            inputRef={fb_pixel_pagesRef}
            sx={{ width: "48%" }}
          />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "20px",
          }}
        >
          <TextField
            label="blocked_pages"
            inputRef={blocked_pagesRef}
            sx={{ width: "48%" }}
          />
          <TextField
            label="session_wt_min"
            inputRef={session_wt_minRef}
            type="number"
            sx={{ width: "48%" }}
          />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "20px",
          }}
        >
          <TextField
            label="live_on"
            inputRef={live_onRef}
            sx={{ width: "48%" }}
          />
          <TextField
            label="cashback_aff"
            inputRef={cashback_affRef}
            sx={{ width: "48%" }}
          />
          <TextField
            label="normal_page_per_k"
            required
            inputRef={normal_page_per_kRef}
            onChange={() => clearError("normal_page_per_k")}
            error={!!errors.normal_page_per_k}
            helperText={errors.normal_page_per_k ? "This field is required" : ""}
            sx={{ width: "48%" }}
            type="number"
          />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "20px",
          }}
        >
          <TextField
            label="cart_page_per"
            required
            inputRef={cart_page_perRef}
            onChange={() => clearError("cart_page_per")}
            error={!!errors.cart_page_per}
            helperText={errors.cart_page_per ? "This field is required" : ""}
            sx={{ width: "48%" }}
            type="number"
          />
          <TextField
            label="min_no_visits"
            required
            inputRef={min_no_visitsRef}
            onChange={() => clearError("min_no_visits")}
            error={!!errors.min_no_visits}
            helperText={errors.min_no_visits ? "This field is required" : ""}
            sx={{ width: "48%" }}
            type="number"
            defaultValue={3}
          />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "20px",
          }}
        >
          <TextField
            label="country"
            inputRef={countryRef}
            sx={{ width: "48%" }}
          />
          <TextField
            label="country_except"
            inputRef={country_exceptRef}
            sx={{ width: "48%" }}
          />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "20px",
          }}
        >
          <FormControl sx={{ width: "48%" }}>
            <InputLabel id="device-multiple-label">device</InputLabel>
            <Select
              labelId="device-multiple-label"
              multiple
              value={selectedDevices}
              onChange={handleDeviceChange}
              input={<OutlinedInput label="device" />}
              renderValue={(selected) => selected.join(", ")}
            >
              {["Desktop", "Mobile", "Tablet", "SmartTV"].map((name) => (
                <MenuItem key={name} value={name}>
                  <Checkbox checked={selectedDevices.indexOf(name) > -1} />
                  <ListItemText primary={name} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            label="black_list_aff_wait_min"
            required
            inputRef={black_list_aff_wait_minRef}
            onChange={() => clearError("black_list_aff_wait_min")}
            error={!!errors.black_list_aff_wait_min}
            helperText={errors.black_list_aff_wait_min ? "This field is required" : ""}
            sx={{ width: "48%" }}
            type="number"
            defaultValue={120}
          />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "20px",
          }}
        >
          <TextField
            label="our_aff_wait_min"
            required
            inputRef={our_aff_wait_minRef}
            onChange={() => clearError("our_aff_wait_min")}
            error={!!errors.our_aff_wait_min}
            helperText={errors.our_aff_wait_min ? "This field is required" : ""}
            sx={{ width: "48%" }}
            type="number"
            defaultValue={30}
          />
          <TextField
            label="aff_active"
            inputRef={aff_activeRef}
            sx={{ width: "48%" }}
            type="number"
          />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "20px",
          }}
        >
          <TextField
            label="retargetting_active"
            required
            inputRef={retargetting_activeRef}
            onChange={() => clearError("retargetting_active")}
            error={!!errors.retargetting_active}
            helperText={errors.retargetting_active ? "This field is required" : ""}
            sx={{ width: "48%" }}
            type="number"
            defaultValue={0}
          />
          <TextField
            label="data_act"
            required
            inputRef={data_actRef}
            onChange={() => clearError("data_act")}
            error={!!errors.data_act}
            helperText={errors.data_act ? "This field is required" : ""}
            sx={{ width: "48%" }}
            type="number"
            defaultValue={0}
          />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "20px",
          }}
        >
          <TextField
            label="aff_wait_hr"
            required
            inputRef={aff_wait_hrRef}
            onChange={() => clearError("aff_wait_hr")}
            error={!!errors.aff_wait_hr}
            helperText={errors.aff_wait_hr ? "This field is required" : ""}
            sx={{ width: "48%" }}
            type="number"
            defaultValue={24}
          />
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Button
            color="success"
            sx={{ width: "10%", textAlign: "center" }}
            type="submit"
            variant="contained"
            startIcon={
              isLoading ? (
                <CircularProgress size={20} color="inherit" />
              ) : (
                <Send />
              )
            }
            disabled={isLoading}
          >
            {isLoading ? "Adding..." : "Add"}
          </Button>
        </div>
      </form>
    </>
  );
};

export default AddRow;
